import bankAccountsReducer, { defaultState, type BankAccounts, type BankAccountsState } from "./bankAccountsReducer";

export { defaultState, type BankAccounts, type BankAccountsState };
export default bankAccountsReducer;
